import { render, staticRenderFns } from "./_QuickActions.vue?vue&type=template&id=406b2b19&"
import script from "./_QuickActions.vue?vue&type=script&lang=js&"
export * from "./_QuickActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports